export function isError(error: unknown): error is Error {
  return typeof error === "object" && error !== null && error instanceof Error;
}
